/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TotalUsers200ResponseMeta } from './totalUsers200ResponseMeta';
import { TotalUsersResource } from './totalUsersResource';


export interface TotalUsers200Response { 
    data: TotalUsersResource;
    meta: TotalUsers200ResponseMeta;
}

